import { createSlice } from "@reduxjs/toolkit";
import VwHbsHastataniDTO from "src/models/HastaServis/VwHbsHastataniDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { HastaTaniApi } from "src/services/HastaServis/HastaTaniApi";

export interface IHastaTaniState {
  aktifMuracaatGoster: boolean;
  aktifServisGoster: boolean;
  data: Array<VwHbsHastataniDTO>;
  activeRow: VwHbsHastataniDTO;
}
const HastaTaniSlice = createSlice<IHastaTaniState, MapReducerPayloads<IHastaTaniState, {
  setState: IHastaTaniState;
  setData: Array<VwHbsHastataniDTO>;
  setActiveRow: VwHbsHastataniDTO;
}>>({
  name: 'hastaTani',
  initialState: {
    aktifMuracaatGoster: true,
    aktifServisGoster: true,
    data: new Array<VwHbsHastataniDTO>(),
    activeRow: new VwHbsHastataniDTO(),
  },
  reducers: {
    setState: (state, action) => action.payload,
    setData: (state, action) => {
      state.data = action.payload;
    },
    setActiveRow: (state, action) => {
      state.activeRow = action.payload;
    },
  },
  extraReducers: (build) => {
    build.addMatcher(HastaTaniApi.endpoints.hastaTaniGetir.matchFulfilled, (state, action) => {
      state.data = action.payload;
    });
  }
})
export default HastaTaniSlice;